module.exports = __webpack_public_path__ + "static/media/mastercard_startpath.cc34be27.png";